class ComplementaryProductCard extends HTMLElement {
  connectedCallback() {
    if (this._inited) return;
    this._inited = true;

    this.product = this.readProduct();
    this.priceRoot = this.querySelector('[data-comp-price]');
    this.image = this.querySelector('.comp-card__image');
    this.addToCartEl = this.querySelector('add-to-cart');
    this.submitButton = this.querySelector('[data-comp-submit]');
    this.submitLabel = this.querySelector('[data-comp-submit-label]');
    this.optionInputs = Array.from(this.querySelectorAll('[data-comp-option]'));

    this.optionInputs.forEach((input) => {
      if (input.tagName === 'SELECT') {
        input.addEventListener('change', () => this.syncUi());
      }
    });

    this.syncUi();
  }

  readProduct() {
    const node = this.querySelector('[data-comp-product]');
    if (!node) return { variants: [] };

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return { variants: [] };
    }
  }

  getSelectedValues() {
    return this.optionInputs
      .slice()
      .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
      .map((input) => input.value);
  }

  findVariant() {
    const selected = this.getSelectedValues();
    if (!this.product?.variants?.length) return null;
    if (!selected.length) return this.product.variants.find((variant) => variant.available) || this.product.variants[0];

    return this.product.variants.find((variant) =>
      selected.every((value, index) => variant.options[index] === value)
    ) || null;
  }

  isValueAvailable(optionIndex, value) {
    const selected = this.getSelectedValues();
    return this.product.variants.some((variant) => {
      if (variant.options[optionIndex] !== value) return false;
      return selected.every((selectedValue, index) => {
        if (index === optionIndex) return true;
        return variant.options[index] === selectedValue;
      }) && variant.available;
    });
  }

  syncUi() {
    const variant = this.findVariant();

    this.querySelectorAll('select[data-comp-option]').forEach((select) => {
      const optionIndex = Number(select.dataset.optionIndex);
      Array.from(select.options).forEach((optionEl) => {
        optionEl.disabled = optionEl.value !== select.value && !this.isValueAvailable(optionIndex, optionEl.value);
      });
    });

    this.renderPrice(variant);
    this.updateImage(variant);
    this.updateSubmit(variant);
  }

  renderPrice(variant) {
    if (!this.priceRoot || !variant) return;

    const compare = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (compare) {
      this.priceRoot.innerHTML = `<div class="price price--${this.priceRoot.dataset.preset || ''}"><div class="price__wrapper"><div class="price__on-sale"><span class="sale-price">${variant.price_formatted}</span></div><div class="price__regular"><s class="regular-price">${variant.compare_at_formatted}</s></div></div></div>`;
      return;
    }

    this.priceRoot.innerHTML = `<div class="price"><div class="price__wrapper"><div class="price__regular"><span class="regular-price">${variant.price_formatted}</span></div></div></div>`;
  }

  updateImage(variant) {
    if (!this.image || !variant?.featured_image) return;
    this.image.src = variant.featured_image;
    this.image.removeAttribute('srcset');
  }

  updateSubmit(variant) {
    if (this.submitButton?.dataset.comingSoon === 'true') return;
    if (this.addToCartEl && variant?.id) {
      this.addToCartEl.dataset.variantId = String(variant.id);
    }

    if (!this.submitButton) return;

    const addLabel = this.submitButton.dataset.labelAdd || '';
    const soldOutLabel = this.submitButton.dataset.labelSoldOut || '';
    const available = Boolean(variant?.available);

    this.submitButton.disabled = !available;
    if (this.submitLabel) this.submitLabel.textContent = available ? addLabel : soldOutLabel;
  }
}

if (!customElements.get('complementary-product-card')) {
  customElements.define('complementary-product-card', ComplementaryProductCard);
}
